import Vue from 'vue';

export default {
    methods: {
        //LIST
        async loadList(enableHookBeforeList = false) {
            if (this.consoleLogs) console.log("loadList", this.id);
            try {
                this.l_loading = true;

                /*
                  run before List if is defined
                */
                if (enableHookBeforeList && this.hookBeforeList !== null && typeof this.hookBeforeList == 'function') {
                    let res = await this.hookBeforeList(this);
                    if (typeof res === 'undefined' || !res) {
                        this.l_loading = false;
                        return res;
                    }
                }
                /*
                  create Hash query String if is Enabled
                */
                if (this.enableUrlModes) {
                    let hash = app.encodeQueryStringParams({
                        idMode:     this.selectedMode.id,
                        filters:    this.getFilters(),
                        orderBy:    this.getOrderBy(),
                        skip:       this.recordsToSkipForNextPage,
                        pageSize:   this.getPageSize(),
                        page:       this.getPage(),
                        components: this.getComponentsConfiguration()
                    });
                    window.history.replaceState(null, null, `?s=${hash}`);
                }
                /*
                  call to api list
                */
                let filters = this.getFilters();
                if (this.requireSingleFacilityId) {
                    // console.log("this.id", this.id);
                    let doNotReturn = false;
                    if (filters.facility_id_csv) {
                        if (typeof filters.facility_id_csv === "String") {
                            if (filters.facility_id_csv.split(',').length > 1) doNotReturn = true;
                        }
                    }
                    if (filters.facility_id_csv === null || filters.facility_id_csv === undefined || filters.facility_id_csv === '') {
                        doNotReturn = true;
                    }
                    if (this.facility_type === 'int') {
                        if (filters.facility_id && typeof filters.facility_id == 'number') {
                            doNotReturn = false;
                        } else {
                            doNotReturn = true;
                        }
                    }
                    if (doNotReturn) {
                        this.l_list   = [];
                        let resultSet = [];
                        this.$emit('onListRecords', {'list': this.l_list, 'resultset': resultSet});
                        return;
                    }
                }

                let campaigns = this.userSelectedCampaigns.filter((cp) => app.auth.user.hasPermission(this.dataProviderPermissions, [cp.campaign_id]));
                if (this.requireSingleCampaignId) {
                    if (!filters['campaign_id']) return;
                }
                if (filters['campaign_id'] == null) filters['campaign_id'] = campaigns.map(c => c.id).join();

                let data = await this.callToList(filters, this.getPage(), this.getPageSize(), this.getOrderBy());
                /*
                  validate result_set necesary for pagination and validation of the list records
                */
                let resultSet = data['result_set'] && data['result_set'][0] ? data['result_set'][0] : false;
                if (resultSet) {
                    if (data[this.defaultListResultSetName]) {
                        this.setSelectedListItemIndex(null);
                        this.l_result.list = data; //save all resultsets returned of the api in result List
                        this.l_list        = data[this.defaultListResultSetName];
                        this.setTotalRecords(resultSet['total_row_count'] ? resultSet['total_row_count'] : 0);
                        setTimeout(() => {
                            this.l_preventFormSubmitOnFilterChangeByCode = false; //disable flag change
                            this.l_loading                               = false;
                        }, 1000);
                        this.$emit('onListRecords', {'list': this.l_list, 'resultset': resultSet});
                    } else {
                        if (this.consoleLogs) console.log("dataprovider", this.id);
                        throw `resultset ${this.defaultListResultSetName} not found`;
                    }
                } else {
                    throw 'Invalid result_set';
                }
            } catch (err) {
                this.l_loading = false;
                app.message(`${this.dataSource} - ${this.id} Error: ${err}`, 'danger');
                console.log('KS-APP loadList: ', this.id, err);
                this.setSelectedListItemIndex(null);
                this.l_list        = [];
                this.l_result.list = [];
                this.setTotalRecords(0);
                this.$emit('onError', err);
                throw err;
            }
        },
        async updateListItem(data) {
            try {
                let updatedListRecord = data[this.defaultListResultSetName] && data[this.defaultListResultSetName][0] ? data[this.defaultListResultSetName] : null;
                if (updatedListRecord) {
                    Vue.set(this.l_list, this.getSelectedListItemIndex(), updatedListRecord);
                    return true;
                } else {
                    let record                                                  = this.getLocalRecord();
                    let requestParameters                                       = {};
                    requestParameters[`${this.defaultCampaignIdName}`]          = record[`${this.defaultCampaignIdName}`];
                    requestParameters[`${this.l_defaultListRecordIdNameInput}`] = record[`${this.defaultUpdateRecordIdNameOutput}`];
                    let list                                                    = await this.callToList(requestParameters);
                    if (list[this.defaultListResultSetName] && list[this.defaultListResultSetName].length > 0) {
                        Vue.set(this.l_list, this.getSelectedListItemIndex(), list[this.defaultListResultSetName][0]);
                        return true;
                    }
                }
                throw 'the list record not can be updated';
            } catch (err) {
                console.log(err);
                return false;
            }
        },
        async inlineUpdate(inputs = {}, enableHookBeforeUpdate = false, enableUpdateListItemOnRecordUpdate = true) {
            try {
                let record = this.l_list[this.getSelectedListItemIndex()];
                if (record && record[this.l_defaultListRecordIdNameOutput] && record[this.defaultCampaignIdName]) {
                    return await this.updatePartialRecord(
                        record[this.defaultCampaignIdName],
                        record[this.l_defaultListRecordIdNameOutput],
                        inputs,
                        enableHookBeforeUpdate,
                        enableUpdateListItemOnRecordUpdate
                    );
                } else {
                    throw "Invalid list record";
                }
            } catch (err) {
                app.message(`${this.dataSource} - ${this.id} Error: ${err}`, 'danger');
                this.$emit('onError', err);
                throw err;
            }
        }
    }
}
